import {
  Group,
  Person,
  Phonelink,
  Security,
  Description,
  Settings,
} from '@material-ui/icons';

const drawerOptions = [
  {
    label: 'Inicio',
    value: 1,
    path: '/home/profile',
    icon: Person,
    permissionNeeded: 'all',// 'none',
    featuresPermissionsNeeded: 'PROFILE_WRITE',
    section: 0,
  },
  {
    label: 'Usuarios',
    value: 2,
    path: '/home/users',
    icon: Group,
    permissionNeeded: 'all',
    featuresPermissionsNeeded: 'USERS_WRITE',
    section: 1,
  },
  {
    label: 'Tipos de documentos',
    value: 4,
    path: '/home/documentTypes',
    icon: Description,
    permissionNeeded: 'all',
    featuresPermissionsNeeded: 'DOCUMENT_TYPES_WRITE',
    section: 1,
  },
  {
    label: 'Grupos de acceso',
    value: 5,
    path: '/home/accessGroups',
    icon: Description,
    permissionNeeded: 'all',
    featuresPermissionsNeeded: 'ACCESS_GROUPS_WRITE',
    section: 1,
  },
  {
    label: 'Logs de Auditoría',
    value: 8,
    path: '/home/audit',
    icon: Description,
    permissionNeeded: 'all',
    featuresPermissionsNeeded: 'AUDIT_LOGS_WRITE',
    section: 1,
  },
  {
    label: 'Configuracion',
    value: 6,
    path: '/home/config',
    icon: Settings,
    permissionNeeded: 'all', //'none',
    featuresPermissionsNeeded: 'CONFIGURATION_WRITE',
    section: 1,
  }
];

const drawerSections = [
  {
    value: 0,
    label: 'Mi cuenta',
  },
  {
    value: 1,
    label: 'Administración',
  },
];

export { drawerOptions, drawerSections };
